import {createAsyncThunk} from '@reduxjs/toolkit';

import request from '@apps-common/js-client/api/request';
import {API_MOSAICS_BASE_PATH} from '../config';
import {getSelectedMosaic} from '../selectors';

export const load = createAsyncThunk(
  'ITEMS_LOAD',
  async (quadId, {getState}) => {
    const state = getState();
    const mosaic = getSelectedMosaic(state);
    if (!mosaic) {
      return;
    }

    return request
      .get(`${API_MOSAICS_BASE_PATH}/${mosaic.id}/quads/${quadId}/items`)
      .then(async res => {
        // TODO: deal with paging
        const items = res.data.items;
        if (!items.length) {
          return [];
        }

        const results = [];

        for (const item of items) {
          const result = await request
            .get(item.link)
            .then(res => res.data)
            .catch(() => null);

          await setTimeout(500);

          if (result) {
            results.push(result);
          }
        }

        return results;
      });
  }
);
